import React from "react"

const InstaIcon = () => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="24" fill="white" />
      <path
        d="M29.6388 32.7527H18.3609C16.8025 32.7527 15.5293 31.4795 15.5293 29.9211V18.6432C15.5293 17.0847 16.8025 15.8115 18.3609 15.8115H29.6388C31.1973 15.8115 32.4705 17.0847 32.4705 18.6432V29.9211C32.4705 31.4865 31.2042 32.7527 29.6388 32.7527Z"
        fill="#111A2F"
      />
      <path
        d="M24.0026 28.6342C22.8408 28.6342 21.7485 28.182 20.9275 27.361C20.1065 26.54 19.6543 25.4477 19.6543 24.2859C19.6543 23.124 20.1065 22.0317 20.9275 21.2107C21.7485 20.3897 22.8408 19.9375 24.0026 19.9375C25.1645 19.9375 26.2568 20.3897 27.0778 21.2107C27.8988 22.0317 28.351 23.124 28.351 24.2859C28.351 25.4477 27.8988 26.54 27.0778 27.361C26.2499 28.182 25.1645 28.6342 24.0026 28.6342ZM24.0026 20.8628C22.1172 20.8628 20.5796 22.3934 20.5796 24.2859C20.5796 26.1713 22.1102 27.7089 24.0026 27.7089C25.8881 27.7089 27.4257 26.1783 27.4257 24.2859C27.4187 22.4004 25.8881 20.8628 24.0026 20.8628Z"
        fill="white"
      />
      <path
        d="M29.2001 19.7948C29.6612 19.7948 30.035 19.421 30.035 18.9599C30.035 18.4988 29.6612 18.125 29.2001 18.125C28.739 18.125 28.3652 18.4988 28.3652 18.9599C28.3652 19.421 28.739 19.7948 29.2001 19.7948Z"
        fill="white"
      />
    </svg>
  )
}

export default InstaIcon
